import React, { useMemo, useCallback, useState } from "react";
import { connect, useLocation } from "dva";
import { QuoteStatus } from "@/utils/enum";
import { getQuotesByStatus } from "@/services/quotes_new";
import ListView from "@/components/ListView";
import { ListToBeSorted } from "@/components/SortAndFilter";
import { useQuotesTableColumns } from "./utils/useQuotesTableColumns";
const Quotes = ({ configPerm }) => {
    const { pathname } = useLocation();
    const [totalItems, setTotalItems] = useState(0);
    const isAdmin = useMemo(() => configPerm["CoreService.AdminShipments"], [configPerm]);
    const quoteStatus = useMemo(() => {
        switch (pathname) {
            case "/quotes/pending":
                return QuoteStatus.Pending;
            case "/quotes/completed":
                return QuoteStatus.Completed;
            default:
                return QuoteStatus.None;
        }
    }, [pathname]);
    const columns = useQuotesTableColumns({
        isCompleted: quoteStatus === QuoteStatus.Completed,
    });
    const currentSubPath = useMemo(() => pathname.split("/").pop(), [pathname]);
    const fetchQuotesList = useCallback(async ({ filters }) => {
        try {
            const response = await getQuotesByStatus({
                ...filters,
                quoteStatus,
            });
            const newTotalItems = response?.totalCount ?? 0;
            setTotalItems(newTotalItems);
            return {
                data: response?.items ?? [],
                total: newTotalItems,
                success: true,
            };
        }
        catch (error) {
            return {
                data: [],
                total: 0,
            };
        }
    }, [quoteStatus]);
    return (React.createElement(ListView, { rowKey: "id", filterType: ListToBeSorted.Quotes, columns: columns, baseDetailsUrl: `/quotes/${isAdmin ? "admin/" : ""}${currentSubPath}/view`, detailsUrlParamName: "shipmentId", totalItems: totalItems, request: fetchQuotesList, rowSelection: false, tableStyle: { paddingLeft: 16, paddingRight: 16 } }));
};
export default connect(({ configs }) => ({
    configPerm: configs.configPerm,
}))(Quotes);
